// Responsible for off canvas menus and transitions.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.panelTarget.classList.remove("invisible")
  }

  toggle() {
    this.panelTarget.classList.toggle("-translate-x-full")
    this.panelTarget.classList.toggle("translate-x-0")
  }

  close() {
    this.panelTarget.classList.add("-translate-x-full")
    this.panelTarget.classList.remove("translate-x-0")
  }
}
